The conflict result for the `updateWebhookSubscriptionDeliveryConfiguration` mutation.

Webhook subscriptions must have a unique combination of `eventTypeCode`, `schemeId`, `url` & `hirerId` fields.
Attempting to update a webhook subscription to match an existing subscription will result in a conflict.
